import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { environment } from "../../../../../libs/api/api";
import { queryTokenBalance } from "../../../../../libs/api/trade/query";
import { walletState } from "../../../../../libs/contexts";
import { leftLessThanRight } from "../../../../../libs/Math";
import TitleLabel from "../../../../common/Labels/TitleLabel";
import style from "./TPTTierTable.module.scss";
import classNames from "classnames/bind";
import { useHistory } from "react-router-dom";
import { PATHS } from "../../../../../App";

enum TPTTier {
    black,
    gold,
    silver,
    general,
}

const cx = classNames.bind(style);

export default function TPTTierTable() {
    const wallet = useRecoilValue(walletState);
    const history = useHistory();
    const [vpBalance, setVpBalance] = useState<string>("0");
    const [tier, setTier] = useState<TPTTier>(TPTTier.general);

    useEffect(() => {
        if (wallet !== undefined) {
            queryTokenBalance(
                environment().contracts.vp_token,
                wallet.terraAddress
            )
                .then((r) => {
                    setVpBalance(r.amount);
                })
                .catch((e) => {
                    setVpBalance("0");
                });
        }
    }, [wallet]);

    useEffect(() => {
        if (!leftLessThanRight(vpBalance, 20000000000)) {
            setTier(TPTTier.black);
        } else if (!leftLessThanRight(vpBalance, 10000000000)) {
            setTier(TPTTier.gold);
        } else if (!leftLessThanRight(vpBalance, 3000000000)) {
            setTier(TPTTier.silver);
        } else {
            setTier(TPTTier.general);
        }
    }, [vpBalance]);

    function tierPressed(pressedTier: TPTTier) {
        if (pressedTier === tier) {
            history.push(PATHS.vp);
        }
    }

    return (
        <div className={style.container}>
            <div className={style.titleWrapper}>
                <div className={style.membership}>{"Membership Tier"}</div>
                <div className={style.dummy} />
                <div className={style.max}>{"Max"}</div>
                <div className={style.min}>{"Min"}</div>
            </div>
            <div className={style.contentWrapper}>
                <div className={style.tier}>
                    <div
                        className={cx(style.tierBox, {
                            highlight: tier === TPTTier.black,
                        })}
                        onClick={() => {
                            tierPressed(TPTTier.black);
                        }}
                    >
                        <div className={style.title}>
                            <div
                                className={cx(style.blackImg, {
                                    highlight: tier === TPTTier.black,
                                })}
                            />
                            <div className={style.webTitle}>
                                {"Black"}
                                <TitleLabel
                                    size={16}
                                    text={""}
                                    color={"#ffffff"}
                                    fontWeight={"light"}
                                    tooltip={"Holds over 20,000VP"}
                                />
                            </div>
                        </div>
                        <div className={style.detail}>
                            <div className={style.luna}>
                                {"6,000 "}
                                <span>{"LUNA"}</span>
                            </div>
                            <div className={style.tptWrapper}>
                                <div className={style.special}>&asymp;</div>
                                <div className={style.tpt}>{"600,000 TPT"}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={cx(style.tierBox, {
                            highlight: tier === TPTTier.gold,
                        })}
                        onClick={() => {
                            tierPressed(TPTTier.gold);
                        }}
                    >
                        <div className={style.title}>
                            <div
                                className={cx(style.goldImg, {
                                    highlight: tier === TPTTier.gold,
                                })}
                            />
                            <div className={style.webTitle}>
                                {"Gold"}
                                <TitleLabel
                                    size={16}
                                    text={""}
                                    color={"#ffffff"}
                                    fontWeight={"light"}
                                    tooltip={"Holds over 10,000VP"}
                                />
                            </div>
                        </div>
                        <div className={style.detail}>
                            <div className={style.luna}>
                                {"4,500 "}
                                <span>{"LUNA"}</span>
                            </div>
                            <div className={style.tptWrapper}>
                                <div className={style.special}>&asymp;</div>
                                <div className={style.tpt}>{"450,000 TPT"}</div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={cx(style.tierBox, {
                            highlight: tier === TPTTier.silver,
                        })}
                        onClick={() => {
                            tierPressed(TPTTier.silver);
                        }}
                    >
                        <div className={style.title}>
                            <div
                                className={cx(style.silverImg, {
                                    highlight: tier === TPTTier.silver,
                                })}
                            />
                            <div className={style.webTitle}>
                                {"Silver"}
                                <TitleLabel
                                    size={16}
                                    text={""}
                                    color={"#ffffff"}
                                    fontWeight={"light"}
                                    tooltip={"Holds over 3,000VP"}
                                />
                            </div>
                        </div>
                        <div className={style.detail}>
                            <div className={style.luna}>
                                {"3,000 "}
                                <span>{"LUNA"}</span>
                            </div>
                            <div className={style.tptWrapper}>
                                <div className={style.special}>&asymp;</div>
                                <div className={style.tpt}>{"300,000 TPT"}</div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={cx(style.tierBox, {
                            highlight: tier === TPTTier.general,
                        })}
                        onClick={() => {
                            tierPressed(TPTTier.general);
                        }}
                    >
                        <div className={style.title}>
                            <div
                                className={cx(style.generalImg, {
                                    highlight: tier === TPTTier.general,
                                })}
                            />
                            <div className={style.webTitle}>
                                {"General"}
                                <TitleLabel
                                    size={16}
                                    text={""}
                                    color={"#000000"}
                                    fontWeight={"light"}
                                />
                            </div>
                        </div>
                        <div className={style.detail}>
                            <div className={style.luna}>
                                {"1,500 "}
                                <span>{"LUNA"}</span>
                            </div>
                            <div className={style.tptWrapper}>
                                <div className={style.special}>&asymp;</div>
                                <div className={style.tpt}>{"150,000 TPT"}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={style.min}>
                    <div className={style.minWrapper}>
                        <div className={style.luna}>
                            {"75 "}
                            <span>{"LUNA"}</span>
                        </div>
                        <div className={style.tptWrapper}>
                            <div className={style.special}>&asymp;</div>
                            <div className={style.tpt}>{"7,500 TPT"}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
